import { v4 as uuidv4 } from 'uuid';

const messages = ['Loading', 'Please wait', 'Almost done'];

const targetMessageMap = {
    appProgress: 'loadMessage',
    loadMoreSchedules: 'loadMoreSchedulesMessage',
    loadingUnsubscribe: 'loadUnsubscribeMessage',
    loadSubscriptions: 'loadSubscriptionsMessage',
};

function getDots(count) {
    if (count <= 1) return '.';
    if (count === 2) return '..';
    return '...';
}

export function updateLoadCounterProgress(target, changeIntervalSeconds) {
    const max = messages.length * changeIntervalSeconds;
    if (this.loadCounter >= max) this.loadCounter = 0;

    const dotsCount = this.loadCounter % changeIntervalSeconds;
    const dots = getDots(dotsCount);
    const msgIndex = Math.floor(this.loadCounter / changeIntervalSeconds);
    let msg = messages[msgIndex] || messages[0];

    this.updateViewProgress(`${msg}${dots}`, target);
}

export function updateViewProgress(msg, target) {
    let propKey = targetMessageMap[target] || 'loadMessage';
    this[propKey] = msg;
    this.observed[propKey] = uuidv4();
}

export function startLoadCounter(options = {}) {
    const { changeIntervalSeconds = 5, target = 'appProgress' } = options;
    this.stopLoadCounter();
    const self = this;
    this.loadCounterTimeout = setInterval(() => {
        self.loadCounter += 1;
        self.updateLoadCounterProgress(target, changeIntervalSeconds);
    }, 500);
}

export function stopLoadCounter() {
    this.loadCounter = 0;
    clearInterval(this.loadCounterTimeout);
}

const loaderActions = { stopLoadCounter, startLoadCounter, updateLoadCounterProgress, updateViewProgress };

export default loaderActions;
